module.exports = __webpack_public_path__ + "images/star33447456c102ec15b81df5055a951968a.gif";